import React, { memo } from "react";
import {
	Row, Col,
	Card, CardBody,
	Button
} from "reactstrap";
import { NavLink } from "react-router-dom";

const SaveAndExitScreen = memo( function SaveAndExitScreen({ mockTitle }) {

	return (
		<div className="content questionsArea deviceTestPage">
			<Row>
				<Col xs={12}>
					<Card>
						<CardBody>
							<Row className='testFinish unselectable'>
								<div className="col-sm-12">
									<h4 className="mt-0">Test Pending</h4>
									<p>
										<span>
											This test is not complete. You can resume this test from <strong>Pending Test area</strong>.
										</span>
									</p>

									<NavLink to={'/admin/pending'}>
										<button className="btn">Continue</button>
									</NavLink>
								</div>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</div>
	);
});

export default SaveAndExitScreen;